<wvr-footer-component [themeVariant]="'secondary'">
  <template footer-content>
    <wvr-nav-list-component aligned="CENTER">
      <template nav-list-items>
        <wvr-nav-li-component *ngFor="let link of links; trackBy:index" [href]="link.href">
          <wvr-text-component [value]="link.value"></wvr-text-component>
        </wvr-nav-li-component>
      </template>
    </wvr-nav-list-component>
  </template>
</wvr-footer-component>
